// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

import messagesOfAfZaLanguage from './messages/af_ZA.json';
import messagesOfArLanguage from './messages/ar.json';
import messagesOfDaLanguage from './messages/da.json';
import messagesOfDeLanguage from './messages/de.json';
import messagesOfDeDeLanguage from './messages/de_DE.json';
import messagesOfElLanguage from './messages/el.json';
import messagesOfEs419Language from './messages/es_419.json';
import messagesOfEsEsLanguage from './messages/es_ES.json';
import messagesOfFaLanguage from './messages/fa.json';
import messagesOfFrCaLanguage from './messages/fr_CA.json';
import messagesOfHeLanguage from './messages/he.json';
import messagesOfHiLanguage from './messages/hi.json';
import messagesOfIdLanguage from './messages/id.json';
import messagesOfItItLanguage from './messages/it_IT.json';
import messagesOfLvLanguage from './messages/lv.json';
import messagesOfPtBrLanguage from './messages/pt_BR.json';
import messagesOfPtPtLanguage from './messages/pt_PT.json';
import messagesOfRuLanguage from './messages/ru.json';
import messagesOfSwLanguage from './messages/sw.json';
import messagesOfTeLanguage from './messages/te.json';
import messagesOfThLanguage from './messages/th.json';
import messagesOfTrTrLanguage from './messages/tr_TR.json';
import messagesOfUkLanguage from './messages/uk.json';
import messagesOfUzLanguage from './messages/uz.json';
import messagesOfViLanguage from './messages/vi.json';
import messagesOfZhCnLanguage from './messages/zh_CN.json';
import messagesOfZhHkLanguage from './messages/zh_HK.json';

export default {
    'af-za': messagesOfAfZaLanguage,
    'zh-hk': messagesOfZhHkLanguage,
    'zh-cn': messagesOfZhCnLanguage,
    'vi': messagesOfViLanguage,
    'uz': messagesOfUzLanguage,
    'uk': messagesOfUkLanguage,
    'tr-tr': messagesOfTrTrLanguage,
    'th': messagesOfThLanguage,
    'te': messagesOfTeLanguage,
    'sw': messagesOfSwLanguage,
    'ru': messagesOfRuLanguage,
    'pt-pt': messagesOfPtPtLanguage,
    'pt-br': messagesOfPtBrLanguage,
    'lv': messagesOfLvLanguage,
    'it-it': messagesOfItItLanguage,
    'id': messagesOfIdLanguage,
    'hi': messagesOfHiLanguage,
    'he': messagesOfHeLanguage,
    'fr-ca': messagesOfFrCaLanguage,
    'fa': messagesOfFaLanguage,
    'es-es': messagesOfEsEsLanguage,
    'es-419': messagesOfEs419Language,
    'el': messagesOfElLanguage,
    'de-de': messagesOfDeDeLanguage,
    'de': messagesOfDeLanguage,
    'da': messagesOfDaLanguage,
    'ar': messagesOfArLanguage,
};
